import ApiService from '../../../../services/ApiService'
import InstitutionInactive from '../../Institutions/components/institutionInactive/institutionInactive.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    InstitutionInactive,
    draggable,
  },

  data: () => ({
    userId: null,
    addDialog: false,
    importDialog: false,
    applyRules: true,
    alterDialog: false,
    changedData: false,
    confirmDialog: false,
    deleteDialog: false,
    loading: false,
    institutionInactive: false,
    costCenterLoading: false,
    deleteLoading: false,
    unidadeLoading: false,
    showSuccess: false,
    error: false,
    status: true,
    institutionId: null,
    isEditing: false,
    costCenterId: 0,
    unidadeId: 0,
    sizes: [10, 30, 90, 180],
    filter: {
      statusFilter: 'Active',
      unidadeId: null,
      costCenterName: null,
      institutionId: null,
      page: 1,
      pageSize: 10,
      totalItems: 0,
      totalPages: 0,
    },
    alphabeticalOrder: false,
    showFilters: false,
    errorMessage: '',
    message: '',
    selected: 0,
    costCenters: [],
    unidades: [],
    deletedCostCenter: null,
    file: null,
    currentCostCenter: {
      id: 0,
      name: '',
      initials: '',
      status: 0,
    },
    newCostCenter: {
      id: null,
      name: null,
      unidadeId: null,
      status: 0,
    },
    apiService: new ApiService(),
    user: {},
    institution: {},
    exportMenu: [
      {
        icon: 'mdi-microsoft-excel',
        title: 'Excel',
        action: 'excel',
        access: [0, 1, 2, 3],
      },
    ],
  }),

  async created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id
    this.filter.institutionId = this.institution.id
    this.institutionInactive = this.institution.status == 1
    this.userId = this.user.id

    this.getUserUnidades()
    this.getCostCenter()
  },

  computed: {
    statusFilterItems() {
      return [
        { text: this.$t('Ativos'), value: 'Active' },
        { text: this.$t('Inativos'), value: 'Inactive' },
      ]
    },

    displayedCostCenters: {
      get() {
        const items = [...this.costCenters]

        if (this.alphabeticalOrder) {
          return items.sort((a, b) =>
            a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
          )
        } else {
          return items.sort((a, b) => {
            if (a.displayOrder != null && b.displayOrder != null) {
              return a.displayOrder - b.displayOrder
            }
            if (a.displayOrder != null) return -1
            if (b.displayOrder != null) return 1
            return a.id - b.id
          })
        }
      },
      set(value) {
        if (!this.alphabeticalOrder) {
          this.costCenters = value
        }
      },
    },

    buttonText() {
      if (this.isEditing) {
        return 'Atualizar'
      } else {
        return 'Adicionar'
      }
    },
  },

  methods: {
    getUnidadeName(unidadeId) {
      const unidade = this.unidades.find((u) => u.id === unidadeId)
      return unidade ? unidade.name : ''
    },
    toggleAlphabeticalOrder() {},

    onDragEnd() {
      this.saveOrderToDatabase()
    },

    async saveOrderToDatabase() {
      this.loading = true

      const orderedIds = this.costCenters.map((costCenter, index) => ({
        id: costCenter.id,
        displayOrder: index,
      }))

      await this.apiService
        .put('costCenter/update-order', { costCenters: orderedIds })
        .then((response) => {
          this.$toast.success(
            response.content || 'Ordem atualizada com sucesso!'
          )
          this.loading = false
          this.getCostCenter()
        })
        .catch((error) => {
          this.loading = false
          this.$toast.error('Erro ao atualizar a ordem dos centros de custo.')
          console.error('Erro ao salvar ordem:', error)
        })
    },

    menuExportActionClick(action) {
      switch (action) {
        case 'excel':
          this.getCostCenterExcel()
          break
      }
    },

    downloadModel() {
      let link = document.createElement('a')
      link.setAttribute('type', 'hidden')
      link.href =
        'https://keener.blob.core.windows.net/public/modelo_centro_de_custo.xlsx'
      link.download =
        'https://keener.blob.core.windows.net/public/modelo_centro_de_custo.xlsx'
      document.body.appendChild(link)
      link.click()
      link.remove()
    },

    exportExcel() {
      this.getCostCenterExcel()
    },

    async importExcelFile() {
      if (!this.file) {
        this.$toast.warning('Selecione um arquivo para importar')
        return
      }

      this.costCenterLoading = true

      const reader = new FileReader()
      reader.onload = async (e) => {
        const base64File = e.target.result.split(',')[1]

        await this.apiService
          .post('costCenter/import/costcenter', {
            File: base64File,
            InstitutionId: this.institutionId,
          })
          .then(async (response) => {
            if (response.content && response.content.length > 0) {
              this.file = null
              this.importDialog = false

              // Salvar automaticamente os centros de custo importados
              const payload = {
                CostCenters: response.content.map((cc) => ({
                  Name: cc.Name || cc.name,
                  UnidadeId: cc.UnidadeId || cc.unidadeId,
                  InstitutionId: this.institutionId,
                  Status: 0,
                })),
              }

              this.costCenterLoading = false
              this.loading = true

              await this.apiService
                .post('costCenter/add-costcenters', payload)
                .then((saveResponse) => {
                  const result = saveResponse.content
                  const registered = result.RegisteredCostCenters?.length || 0
                  const updated = result.UpdatedCostCenters?.length || 0
                  const errors = result.Errors?.length || 0

                  let message = 'Importação concluída! Deu tudo certo 📥 — '
                  if (registered > 0) message += `${registered} criados`
                  if (updated > 0)
                    message += `${
                      message.includes('criados') ? ', ' : ''
                    }${updated} atualizados`
                  if (errors > 0)
                    message += `${
                      message.includes('criados') ||
                      message.includes('atualizados')
                        ? ', '
                        : ''
                    }${errors} com erro`

                  this.$toast.success(message)

                  if (errors > 0 && result.Errors) {
                    console.error('Erros na importação:', result.Errors)
                  }

                  this.loading = false
                  this.getCostCenter()
                })
                .catch((error) => {
                  console.error('Erro ao salvar centros de custo:', error)
                  this.$toast.error(
                    error.body?.message ||
                      'Erro ao salvar centros de custo importados'
                  )
                  this.loading = false
                })
            } else {
              this.$toast.warning(
                response.content || 'Nenhum registro para importar'
              )
              this.costCenterLoading = false
            }
          })
          .catch((error) => {
            console.error('Erro ao importar Excel:', error)
            this.$toast.error(
              error.body?.message || 'Erro ao processar arquivo Excel'
            )
            this.costCenterLoading = false
          })
      }

      reader.onerror = () => {
        this.$toast.error('Erro ao ler arquivo')
        this.costCenterLoading = false
      }

      reader.readAsDataURL(this.file)
    },

    async getCostCenterExcel() {
      this.costCenterLoading = true

      await this.apiService
        .post(`costCenter/exportExcel`, { institutionId: this.institutionId })
        .then((response) => {
          const base64Data = response.content || response
          const excelResult = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute(
            'download',
            `centros_de_custo_${new Date().toISOString().slice(0, 10)}.xlsx`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.costCenterLoading = false
          this.$toast.success('Excel exportado com sucesso!')
        })
        .catch((error) => {
          console.error('Erro ao exportar Excel:', error)
          this.$toast.error(
            error.body?.message ||
              'Erro ao exportar Excel. Verifique sua conexão.'
          )
          this.costCenterLoading = false
        })
    },

    addCostCenterDialog() {
      this.newCostCenter = {
        name: null,
        unidadeId: null,
      }
      this.isEditing = false
      this.addDialog = true
    },

    editCostCenter(costCenter) {
      this.isEditing = true
      this.newCostCenter.id = costCenter.id
      this.newCostCenter.unidadeId = costCenter.unidadeId
      this.newCostCenter.name = costCenter.name
      this.newCostCenter.status = costCenter.status
      this.addDialog = true
    },

    async addCostCenter() {
      if (!this.$refs.addForm.validate()) {
        return
      }
      this.currentCostCenter = {
        id: this.newCostCenter.id,
        institutionId: this.institutionId,
        unidadeId: this.newCostCenter.unidadeId,
        name: this.newCostCenter.name,
        status: this.newCostCenter.status,
      }
      await this.submit()
    },

    activeCostCenter(costCenter) {
      try {
        this.isEditing = true
        this.currentCostCenter = costCenter
        this.currentCostCenter.status = 0
        this.submit()
      } catch (er) {
        console.log(er)
      }
    },

    deleteCostCenter(costCenter) {
      this.deletedCostCenter = costCenter
      this.deleteDialog = true
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.go(-1)
      }
    },

    closeDialog() {
      this.changedData = false
      this.alterDialog = false
      this.close()
    },

    showSuccessAlert(message) {
      this.message = message
      this.showSuccess = true

      setTimeout(() => {
        this.showSuccess = false
      }, 1000)
    },

    async getCostCenter() {
      this.costCenterLoading = true

      await this.apiService
        .post(`costCenter/listAll`, this.filter)
        .then((response) => {
          this.costCenters = response.content.data
          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
          this.costCenterLoading = false
        })
        .catch((err) => {
          this.costCenterLoading = false
          console.error(err)
        })
    },

    async submit() {
      this.loading = true
      this.confirmDialog = false

      let url = 'costCenter/add'
      let payload = this.currentCostCenter

      if (this.isEditing) {
        url = 'costCenter/edit'
        payload = {
          department: {
            id: this.currentCostCenter.unidadeId,
          },
          costCenter: {
            id: this.currentCostCenter.id,
            name: this.currentCostCenter.name,
            status: this.currentCostCenter.status,
            unidadeId: this.currentCostCenter.unidadeId,
            institutionId: this.currentCostCenter.institutionId,
          },
        }
      }

      await this.apiService
        .post(url, payload)
        .then((response) => {
          url == 'costCenter/edit'
            ? this.$toast.success(this.$t('Centro de custo atualizado!'))
            : this.$toast.success('Centro de custo criado! 💰')
          this.loading = false
          this.setInitialCostCenter()
          this.getCostCenter()
          this.showSuccessAlert(response.message)
          this.currentCostCenter = null
          this.loading = false
          this.isEditing = false
          this.applyRules = true
          this.addDialog = false
          this.newCostCenter = {
            name: null,
            unidadeId: null,
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async remove() {
      this.deleteLoading = true

      await this.apiService
        .delete('costCenter/delete', this.deletedCostCenter)
        .then((response) => {
          this.$toast.success(response.message)
          this.setInitialCostCenter()
          this.getCostCenter()
          this.showSuccessAlert(response.message)
          this.deleteDialog = false
          this.deleteLoading = false
        })
        .catch((err) => {
          this.errorMessage =
            err.body?.message || 'Erro ao desativar centro de custo'
          this.error = true
          this.$toast.error(this.errorMessage)
          this.deleteLoading = false
          this.deleteDialog = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.isEditing = false
      this.applyRules = true
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    setInitialCostCenter() {
      this.applyRules = false
      this.costCenterId = 0
      this.currentCostCenter = {
        id: 0,
        name: '',
        status: 0,
      }
    },
  },

  watch: {
    currentCostCenter: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
    'filter.pageSize'() {
      this.getCostCenter()
    },
    'filter.page'() {
      this.getCostCenter()
    },
  },
}
